export default __webpack_public_path__ + "static/media/s2img4.494cc64a.png";